export default __webpack_public_path__ + "static/media/bubble-vr.8a73bb3d.png";